// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prop-card {
  padding: 16px 17px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
}

.prop-card-accepted {
  border-color: #6ee7b7;
  background: #f0fdf9;
}

.prop-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.prop-avatar {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
}

.prop-avatar-fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--grad-brand);
  color: #fff;
  font-family: var(--font-display);
  font-size: 0.86rem;
  font-weight: 700;
}

.prop-who {
  flex: 1 1;
  min-width: 0;
}

.prop-name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  font-family: var(--font-display);
  font-size: 0.96rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 3px;
}

.prop-tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 8px;
  border-radius: var(--radius-pill);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.prop-tag-premium {
  background: #fef3c7;
  color: #92400e;
}

.prop-tag-verified {
  background: var(--brand-100);
  color: var(--brand-800);
}

.prop-price {
  flex-shrink: 0;
  text-align: right;
}

.prop-price strong {
  display: block;
  font-family: var(--font-display);
  font-size: 1.12rem;
  font-weight: 800;
  line-height: 1.2;
  color: var(--brand);
}

.prop-price span {
  font-size: 0.78rem;
  color: var(--muted);
}

.prop-desc {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
  font-size: 0.88rem;
  line-height: 1.6;
  color: var(--text-soft);
  white-space: pre-wrap;
}

.prop-actions {
  display: flex;
  gap: 9px;
  margin-top: 14px;
}

.prop-accept,
.prop-reject {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 11px 16px;
  border-radius: var(--radius-sm);
  font-family: var(--font-display);
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.prop-accept {
  flex: 1 1;
  border: 0;
  background: var(--brand);
  color: #fff;
}

.prop-accept:hover:not(:disabled) {
  background: var(--brand-700);
}

.prop-reject {
  border: 1.5px solid var(--border);
  background: #fff;
  color: var(--muted);
}

.prop-reject:hover:not(:disabled) {
  border-color: var(--danger-100);
  background: var(--danger-50);
  color: var(--danger);
}

.prop-accept:disabled,
.prop-reject:disabled {
  opacity: 0.6;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/ProposalCard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,SAAS;EACT,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".prop-card {\n  padding: 16px 17px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n}\n\n.prop-card-accepted {\n  border-color: #6ee7b7;\n  background: #f0fdf9;\n}\n\n.prop-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.prop-avatar {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.prop-avatar-fallback {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--grad-brand);\n  color: #fff;\n  font-family: var(--font-display);\n  font-size: 0.86rem;\n  font-weight: 700;\n}\n\n.prop-who {\n  flex: 1;\n  min-width: 0;\n}\n\n.prop-name {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 7px;\n  font-family: var(--font-display);\n  font-size: 0.96rem;\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 3px;\n}\n\n.prop-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 8px;\n  border-radius: var(--radius-pill);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n\n.prop-tag-premium {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.prop-tag-verified {\n  background: var(--brand-100);\n  color: var(--brand-800);\n}\n\n.prop-price {\n  flex-shrink: 0;\n  text-align: right;\n}\n\n.prop-price strong {\n  display: block;\n  font-family: var(--font-display);\n  font-size: 1.12rem;\n  font-weight: 800;\n  line-height: 1.2;\n  color: var(--brand);\n}\n\n.prop-price span {\n  font-size: 0.78rem;\n  color: var(--muted);\n}\n\n.prop-desc {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n  font-size: 0.88rem;\n  line-height: 1.6;\n  color: var(--text-soft);\n  white-space: pre-wrap;\n}\n\n.prop-actions {\n  display: flex;\n  gap: 9px;\n  margin-top: 14px;\n}\n\n.prop-accept,\n.prop-reject {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 11px 16px;\n  border-radius: var(--radius-sm);\n  font-family: var(--font-display);\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.prop-accept {\n  flex: 1;\n  border: 0;\n  background: var(--brand);\n  color: #fff;\n}\n\n.prop-accept:hover:not(:disabled) {\n  background: var(--brand-700);\n}\n\n.prop-reject {\n  border: 1.5px solid var(--border);\n  background: #fff;\n  color: var(--muted);\n}\n\n.prop-reject:hover:not(:disabled) {\n  border-color: var(--danger-100);\n  background: var(--danger-50);\n  color: var(--danger);\n}\n\n.prop-accept:disabled,\n.prop-reject:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
